import Quill from 'quill';

const Inline = Quill.import('blots/inline');

class UnderlineBelowBlot extends Inline {
  static create() {
    const node = super.create();
    node.style.borderBottom = '1px solid #000';
    node.style.display = 'inline-block';
    node.classList.add('underline-below');
    return node;
  }

  static formats(node) {
    return node.classList.contains('underline-below');
  }
}

UnderlineBelowBlot.blotName = 'underlineBelow';
UnderlineBelowBlot.tagName = 'span';
UnderlineBelowBlot.className = 'underline-below';

Quill.register('formats/underlineBelow', UnderlineBelowBlot);

export function addUnderlineBelowHandler(quill) {
  const toolbar = quill.getModule('toolbar');
  if (toolbar) {
    toolbar.addHandler('underline-below', function() {
      const range = quill.getSelection(true);
      if (!range) return;

      const format = quill.getFormat(range);
      quill.formatText(
        range.index,
        range.length,
        'underlineBelow',
        !format['underlineBelow']
      );
    });
  }
}

export default UnderlineBelowBlot;
